import { useDispatch, useSelector } from 'hooks/utils';
import { LocalOperationResult } from 'hooks/store/types';
import { setVariablesSearchTerm } from 'store/data/variables';

export function useVariablesSearchTerm(): LocalOperationResult<string, (term: string) => void> {
	const dispatch = useDispatch();

	const data = useSelector(state => state.data.variables.metadata.searchTerm);

	function handler(term: string) {
		dispatch(setVariablesSearchTerm({ term }));
	}

	return [data, handler];
}
